import React, { useState } from 'react';
import { FaFileExport } from "react-icons/fa";

const LayerExport = ({ layer }) => {
    const [showOptions, setShowOptions] = useState(false);

    const data = layer.props?.data?.data ?? layer.props?.data;
    if (!data?.features) return null;

    const download = (format) => {
        let content = "", mimeType = "", extension = "";

        switch (format) {
            case "geojson":
                content = JSON.stringify(data, null, 2);
                mimeType = "application/geo+json";
                extension = "geojson";
                break;
            case "kml":
                content = jsonToKml(data);
                mimeType = "application/vnd.google-earth.kml+xml";
                extension = "kml";
                break;
            case "gml":
                content = jsonToGml(data);
                mimeType = "application/gml+xml";
                extension = "gml";
                break;
            default:
                return;
        }

        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${layer.id}.${extension}`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const jsonToKml = (geojson) => {
        const features = geojson.features ?? [];
        const placemarks = features.map(f => {
            const coords = f.geometry.coordinates.flat(Infinity).join(',');
            return `<Placemark><name>${f.properties?.name ?? 'Feature'}</name><Point><coordinates>${coords}</coordinates></Point></Placemark>`;
        }).join("");
        return `<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2"><Document>${placemarks}</Document></kml>`;
    };

    const jsonToGml = (geojson) => {
        const features = geojson.features ?? [];
        const gmlFeatures = features.map((f, i) => `
            <gml:featureMember>
                <feature fid="${layer.id}.${i}">
                    <geometry>${JSON.stringify(f.geometry)}</geometry>
                    ${Object.entries(f.properties).map(([k, v]) => `<${k}>${v}</${k}>`).join("")}
                </feature>
            </gml:featureMember>
        `).join("\n");
        return `<?xml version="1.0" encoding="UTF-8"?>
            <gml:FeatureCollection xmlns:gml="http://www.opengis.net/gml">
                ${gmlFeatures}
            </gml:FeatureCollection>`;
    };

    return (
        <div style={{ marginTop: '8px' }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span>Izvezi:</span>
                <button
                    onClick={() => setShowOptions(!showOptions)}
                    style={{
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                        color: "#fff"
                    }}
                    title="Prikaži opcije izvoza"
                >
                    <FaFileExport />
                </button>
            </div>

            {showOptions && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                    marginTop: '8px'
                }}>
                    {["geojson", "kml", "gml"].map(fmt => (
                        <button
                            key={fmt}
                            onClick={() => download(fmt)}
                            title={`Izvezi kao ${fmt.toUpperCase()}`}
                            style={{
                                width: '100%',
                                height: '36px',
                                padding: '6px 12px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                backgroundColor: '#f7f7f7',
                                color: '#000',
                                cursor: 'pointer',
                                fontWeight: 500,
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseOver={e => e.target.style.backgroundColor = "#e0e0e0"}
                            onMouseOut={e => e.target.style.backgroundColor = "#f7f7f7"}
                        >
                            {fmt.toUpperCase()}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LayerExport;
